import './continueButton.scss';

export const ContinueButton = angular
    .module('checkout.components.continueButton', [])
    .component('continueButton', {
        transclude: true,
        template: `
            <button
                class="checkout-button checkout-button--primary checkout-button--large continue-button"
                type="{{$ctrl.buttonType}}"
                ng-disabled="$ctrl.isDisabled"
                ng-click="$ctrl.onClicked({ $event: $event })">
                <div layout layout-align="center center">
                    <span ng-if="!$ctrl.isLoading">
                        <ng-transclude></ng-transclude>
                    </span>
                    <md-progress-circular
                        ng-if="$ctrl.isLoading"
                        md-diameter="{{$ctrl.spinnerSize || 25}}"
                        md-mode="indeterminate">
                    </md-progress-circular>
                </div>
            </button>
        `,
        bindings: {
            isDisabled: '<',
            isLoading: '<',
            onClicked: '&',
            spinnerSize: '<',
            buttonType: '@'
        },
        controller: class ContinueButtonCtrl {
            $onInit() {
                this.buttonType = this.buttonType || 'button';
            }
        }
    }).name;



// WEBPACK FOOTER //
// ./src/app/components/continueButton/continueButton.js